<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Cymm6W/tc-custom/9781466810204.jpg?1738254564926" alt="This image is the cover for the book Something More Than Night"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Something More Than Night
      </h1>
      <p class="bookDescription body article font2">
        <p>Ian Tregillis's <i>Something More Than Night</i> is a Dashiell Hammett and Raymond Chandler inspired murder mystery set in Thomas Aquinas's vision of Heaven. It's a noir detective story starring fallen angels, the heavenly choir, nightclub stigmatics, a priest with a dirty secret, a femme fatale, and the Voice of God.<br/><br/>Somebody has murdered the angel Gabriel. Worse, the Jericho Trumpet has gone missing, putting Heaven on the brink of a truly cosmic crisis. But the twisty plot that unfolds from the murder investigation leads to something much bigger: a con job one billion years in the making. <br/><br/>Because this is no mere murder. A small band of angels has decided to break out of heaven, but they need a human patsy to make their plan work.<br/><br/>Much of the story is told from the point of view of Bayliss, a cynical fallen angel who has modeled himself on Philip Marlowe. The yarn he spins follows the progression of a Marlowe novel—the mysterious dame who needs his help, getting grilled by the bulls, finding a stiff, getting slipped a mickey.<br/>Angels and gunsels, dames with eyes like fire, and a grand maguffin, <i>Something More Than Night</i> is a murder mystery for the cosmos. <br/>A <i>Kirkus Reviews </i>Best Fiction Book of 2013<br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ian Tregillis
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bd1d1c58